<template>
    <el-dialog v-model="visible" title="设置户主" width="500px" append-to-body :close-on-click-modal="false">
        <el-form ref="formRef" :model="form" label-width="100px" style="margin-top: 10px">
            <!-- 隐藏ID -->
            <el-input v-model="form.id" type="hidden" />

            <el-form-item label="户主姓名" prop="household" required>
                <el-input v-model="form.household" placeholder="请输入户主姓名" style="width: 100%" clearable />
            </el-form-item>

            <el-form-item label="联系电话" prop="phone" required>
                <el-input v-model="form.phone" placeholder="请输入联系电话" style="width: 100%" clearable />
            </el-form-item>
        </el-form>

        <template #footer>
            <div class="text-right">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="primary" @click="submit">确认</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { setHousehold } from '@/api/building'

const visible = ref(false)
const formRef = ref(null)

const form = reactive({
    id: '',
    household: '',
    phone: ''
})

const emit = defineEmits(['success'])

// 打开弹窗（传入房屋id + 原有户主信息）
function open(row = {}) {
    visible.value = true
    form.id = row.id || ''
    form.household = row.household || ''
    form.phone = row.phone || ''
}

// 提交
async function submit() {
    if (!form.household) {
        ElMessage.warning('请输入户主姓名')
        return
    }
    if (!form.phone) {
        ElMessage.warning('请输入联系电话')
        return
    }
    await setHousehold(form)
    // 提交成功后回调给父组件
    emit('success', { ...form })
    ElMessage.success('设置户主成功')
    visible.value = false
}

defineExpose({ open })
</script>

<style scoped>
.text-right {
    text-align: right;
}
</style>
